import React from 'react';
import { Grid } from '@material-ui/core';
import {
  Create,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  SelectInput,
  SelectArrayInput,
  ReferenceArrayInput,
  required,
  maxLength,
} from 'react-admin';
import Toolbar from '../resource-toolbar';
import { LanguageChanger } from '../fields';
import { useServerValidation, useLanguageChange, getStyle } from '../../helpers';
import { COUNTRIES, LANGUAGES, LICENSE_TYPES, PRICE_TIER } from '../../constants';

export default (props) => {
  const { onFailure } = useServerValidation();
  const [defaultLanguage] = LANGUAGES;
  const { language, onLanguageChange } = useLanguageChange(defaultLanguage);
  return (
    <Grid item lg={6} md={8} xs={12}>
      <Create {...props} onFailure={onFailure}>
        <SimpleForm toolbar={<Toolbar resourceName="artists" />}>
          <TextInput source="first_name" fullWidth validate={required()} />
          <TextInput source="last_name" fullWidth validate={required()} />
          <ImageInput source="files" label="Photo" accept="image/*">
            <ImageField source="photo" title="Artist Photo" />
          </ImageInput>
          <SelectInput source="country" translateChoice={false} choices={COUNTRIES} fullWidth validate={required()} />
          <ReferenceArrayInput
            label="Art Types"
            source="artTypes"
            reference="art-types"
            sort={{ field: 'name', order: 'ASC' }}
            fullWidth
          >
            <SelectArrayInput
              optionText="name"
              validate={required()}
            />
          </ReferenceArrayInput>
          <SelectInput
            source="license_type"
            translateChoice={false}
            choices={LICENSE_TYPES}
            fullWidth
          />
          <SelectInput
            source="price_tier"
            translateChoice={false}
            choices={PRICE_TIER}
            fullWidth
          />
          <LanguageChanger language={language} onLanguageChange={onLanguageChange} />
          <TextInput style={getStyle(language, '_en')} rows="15" multiline label="Biography" source="description" fullWidth validate={maxLength(10000)} />
          <TextInput style={getStyle(language, '_fr')} rows="15" multiline label="Biography FR" source="description_fr" fullWidth validate={maxLength(10000)} />
          <TextInput style={getStyle(language, '_jp')} rows="15" multiline label="Biography JP" source="description_jp" fullWidth validate={maxLength(10000)} />
          <TextInput style={getStyle(language, '_cn')} rows="15" multiline label="Biography CN" source="description_cn" fullWidth validate={maxLength(10000)} />
          <TextInput style={getStyle(language, '_de')} rows="15" multiline label="Biography DE" source="description_de" fullWidth validate={maxLength(10000)} />
          <TextInput style={getStyle(language, '_kr')} rows="15" multiline label="Biography KR" source="description_kr" fullWidth validate={maxLength(10000)} />
          <TextInput style={getStyle(language, '_es')} rows="15" multiline label="Biography ES" source="description_es" fullWidth validate={maxLength(10000)} />
        </SimpleForm>
      </Create>
    </Grid>
  );
};
